import { jsPDF } from 'jspdf';
import 'jspdf-autotable';

export const generateFinancialReport = async (companyId: string) => {
  const doc = new jsPDF();
  
  // Add company info
  const { data: company } = await supabase
    .from('companies')
    .select('*')
    .eq('id', companyId)
    .single();

  doc.setFontSize(20);
  doc.text(`Financial Report - ${company.name}`, 20, 20);
  doc.setFontSize(12);
  doc.text(`Generated on ${format(new Date(), 'MMMM d, yyyy')}`, 20, 30);

  // Add expense summary
  const { data: expenses } = await supabase
    .from('company_expenses')
    .select('*')
    .eq('company_id', companyId);

  doc.autoTable({
    head: [['Category', 'Amount', 'Description']],
    body: expenses.map(expense => [
      expense.category,
      `$${expense.amount.toLocaleString()}`,
      expense.description
    ]),
    startY: 40
  });

  // Save the PDF
  doc.save(`financial-report-${company.name}-${format(new Date(), 'yyyy-MM-dd')}.pdf`);
};